import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SuffixService {
    private rootUrl: string = "/api/suffixes";

    constructor(private httpClient: HttpClient) { }

    public getSuffixes(): Observable<string[]> {
        const url = this.rootUrl;
        return this.httpClient.get<string[]>(url);
    }
}
